<template>
    <div id="cart-view">
        <div v-if="paymentURL === null">
            <product-resume/>
            <subtittle-section :content="this.$route.meta.navigation.subtitle()" class="subtitle-section"/>
            <cart-summary />
            <div id="promotion-container" v-if="showPromotionInput">
                <div class="px-6 pt-4 pb-2">
                    <span class="font-medium">{{ $t("review.promotion.add") }}</span>
                </div>
                <div class="bg-white pb-4">
                    <ria-input
                        class="px-6"
                        :label="i18n.t('review.promotion.introduce')"
                        :value="promocode"
                        @change="changeValue"
                        :disabled="Object.keys(promoCode).length > 0 && !promoCode.error"
                        type="text"/>
                    <button :disabled="Object.keys(promoCode).length > 0 && !promoCode.error" @click="checkPromoCode" id="validate-promo">{{$t("review.promotion.validate")}}</button>
                    <img id="remove-promo" @click="deletePromotion" v-if="this.promocode !== null && this.promocode !== ''" src="/img/icons/icon-grey-close.svg">
                    <div id="error-promo" class="px-6" v-if="this.promoCode.error">
                        <div class="bg-error rounded p-2">
                            <span class="text-white">{{ $t("review.promotion.error") }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pl-6 pr-6 mb-1 lg:mb-0">
                <div v-if="!showPromotionInput" class="pt-5">
                    <ria-button class="uppercase" :text="i18n.t('review.promotion.add')" :outline="true" :fullwidth="true" :action="addPromotion"/>
                </div>
                <div class="py-4 text-grey-text text-center">
                    <div class="inline-block w-4 align-top pt-1" @click="accept">
                        <inline-svg
                            v-bind:class="{ 'opacity-50': !resort.pageConditions }"
                            class="check"
                            :src="enabled ? '/img/icons/icon-checkactive.svg' : '/img/icons/icon-check.svg'"
                        />
                    </div>
                    <div class="inline-block w-11/12 text-left pl-3 tracking-base">
                        <label @click="accept" class="text-xs">{{ $t("review.accept") }} &nbsp;</label>
                        <a @click="modal" class="text-xs underline cursor-pointer">{{ $t("review.conditions") }}</a>
                        <span class="text-xs">&nbsp;{{ $t("review.and") }}&nbsp;</span>
                        <a :href="urlPrivacy" class="text-xs underline">{{ $t("review.privacy") }}</a>
                    </div>
                </div>
            </div>
            <div class="modal-elements">
                <modal :closeButtonText="i18n.t('review.ok')" @close="modal" v-if="resort.pageConditions != null && showModal">
                    <div slot="title">
                        <span>{{translate(resort.pageConditions, 'name')}}</span>
                    </div>
                    <div class="text-justify px-3" slot="body">
                        <span class="whitespace-pre-line" v-html="translate(resort.pageConditions, 'description')"></span>
                    </div>
                </modal>
                <modal :closeButtonText="i18n.t('review.cancel')" @close="modalpayment" v-if="showModalPayment">
                    <div slot="title">
                        <span class="text-base text-grey-text">{{$t("review.selectpayment")}}</span>
                    </div>
                    <div slot="body">
                        <div v-for="payment in resort.paymentGateways" :key="payment.id">
                            <ria-button class="button-continue block mx-0 my-5 uppercase lg:float-right" :text="translate(payment, 'button')" :action="() => paymentSelected(payment.id)" fullwidth/>
                        </div>
                    </div>
                </modal>
                <modal :closeButtonText="i18n.t('review.ok')" @close="modalconditions" v-if="showModalConditions">
                    <div slot="body">
                        <span>{{ $t("review.acceptconditions") }}</span>
                    </div>
                </modal>
            </div>
            <div v-html="paymentForm"></div>
            <continue :price="(totalPrice)" :button-text="i18n.t('review.pay')" :button-action="paymentButton" :active="true" />
        </div>
        <iframe class="w-full h-screen p-5" v-if="paymentURL !== null" :src="paymentURL" />
    </div>
</template>

<script>
import i18n from '../i18n';
import Modal from "@/components/common/modal";
import Continue from "@/components/common/continue";
import CartSummary from '@/components/common/cart-summary'
import SubtittleSection from "@/components/common/subtittle-section";
import ProductResume from "@/views/participants/components/product-resume";
import {translate}  from '@/helpers/translationsHelpers.js';
import { mapGetters, mapActions } from 'vuex';
import RiaButton from "@/components/common/ria-button";
import {keepScroll} from "../mixins";
import RiaInput from "@/components/form/elements/ria-input";
import { loadStripe } from '@stripe/stripe-js/pure';

export default {
    name: "Cart",
    metaInfo() {
        return { 
            title: `${this.$t('cart.meta.title')} - ${this.resort.name}`,
            meta: [
                { name: 'description', content:  this.$t('cart.meta.description')}, 
            ]
        }
    },
    mixins: [keepScroll],
    components: {
        ProductResume,
        SubtittleSection,
        Continue,
        Modal,
        CartSummary,
        RiaButton,
        RiaInput
    },
    data: function() {
      return {
        enabled: false,
        i18n: i18n,
        showModal: false,
        showModalPayment: false,
        showModalConditions: false,
        showPromotionInput: false,
        customOrder: {},
        paymentForm: null,
        paymentURL: null,
        promocode: null
      }
    },
    methods: {
        ...mapActions("order", ["sendCheckout", "setOrderField"]),
        ...mapActions("prices", ["loadProductPrices", "loadExtrasPrices", "loadKeycard", "loadPromoCode", "resetPromoCode"]),
        paymentSelected: function(selected){
            const errors = {'SHOP_CLOSED': -100, 'APP_CLOSED': -101, 'WEB_CLOSED': -102}
            this.customOrder.payment_gateway_id = selected;
            window.dispatchEvent(new CustomEvent('showSpinner'))
            this.sendCheckout(this.customOrder).then(() => {
                window.dispatchEvent(new CustomEvent('hideSpinner'))
                switch(this.checkout.method){
                    case 'free':
                    case 'netaxept':
                    case 'paypal':
                        window.location.href = this.checkout.payment
                        break;
                    case 'paybox':
                    case 'redsys':
                        this.paymentForm = this.checkout.payment
                        setTimeout(function(){
                            document.getElementById("payment_form").submit();
                        }, 1500);
                        break;
                    case 'paycomet':
                        this.paymentURL = this.checkout.payment
                        break;
                    case 'stripe':
                        console.log('loading Stripe')
                        loadStripe.setLoadParameters({ advancedFraudSignals: false });
                        loadStripe(this.checkout.payment.publicKey).then((stripe) => {
                            console.log('loaded')
                            stripe.redirectToCheckout({ sessionId: this.checkout.payment.sessionId});
                        });
                        break;
                }
            }).catch((error) => {
                window.dispatchEvent(new CustomEvent('hideSpinner'))
                console.log('error cart:', error)
                switch(error.response.data.error.code){
                    case errors.SHOP_CLOSED:
                        this.$router.push({ name: 'NoProducts' })
                        break;
                }
            });
        },
        modalpayment: function() {
            this.showModalPayment = !this.showModalPayment
        },
        modal: function() {
            this.showModal = !this.showModal
        },
        modalconditions: function() {
            this.showModalConditions = !this.showModalConditions
        },
        addPromotion: function(){
            this.showPromotionInput = !this.showPromotionInput
        },
        deletePromotion: function(){
            this.promocode = null
            this.resetPromoCode()
        },
        translate(object, field) {
            return translate(object, field)
        },
        accept: function(){
            if(this.resort.pageConditions)
                this.enabled = !this.enabled
        },
        paymentButton: function(){
            if(this.enabled && this.totalPrice > 0)
                this.modalpayment()
            else if(this.enabled && this.totalPrice < 0)
                this.paymentSelected(0)
            else
                this.modalconditions()
        },
        changeValue: function({ value }) {
            this.promocode = value
        },
        checkPromoCode: async function(){
            await this.loadPromoCode({
                product_id: this.selectedProduct.id,
                resort_id: this.resort.id, 
                promotion_code: this.promocode, 
                customer_id: this.customer ? this.customer.id : null,
                participant_ids: [...new Set(this.details.map((detail) => detail.participant_id))]
            })
            this.customOrder.promotion_id = this.promoCode.id
        }
    },
    computed: {
        ...mapGetters('order', ['details', 'totalPrice', 'order', 'checkout', 'totalPricePromo']),
        ...mapGetters('resort', ['resort', 'selectedProduct', 'selectedCatalog', 'environment_id']),
        ...mapGetters('prices', ['extraPrice', 'keycard', 'loadedExtras', 'promoCode', 'promoActive']),
        ...mapGetters('device', ['language']),
        ...mapGetters('auth', ['testingMode']),
        ...mapGetters('customer', ['customer']),
        active: function () {
            return this.enabled ? 'active' : ''
        },
        urlPrivacy: function(){
            return `https://www.skitude.com/${this.language}/terms-and-conditions?x_skitude_external_page=true`
        }
    },
    async created() {
        await this.loadProductPrices({
            productid: this.selectedProduct.id,
            name: this.translate(this.selectedProduct, 'name')
        });
        if(this.loadedExtras)
            await this.loadExtrasPrices({
                extras: this.selectedProduct.extras.map((ext) => ext.id),
                date: this.selectedProduct.requirements.date ? this.details[0].date : null
        });
        if(this.keycard && this.selectedProduct.keycard){
            await this.loadKeycard({
                keycardid: this.selectedProduct.keycard.id
            });
        }
        this.setOrderField({field: 'resort_id', value: this.resort.id});
        this.setOrderField({field: 'environment_id', value: this.environment_id});
        this.customOrder = JSON.parse(JSON.stringify(this.order))
        this.customOrder.details.filter(detail => {
            if(detail.keycard && detail.keycard.new)
                detail.keycard = null
            else if(detail.keycard && detail.keycard.number)
                detail.keycard = detail.keycard.number
        })
        if(this.testingMode)
            this.customOrder.force = true
    }
}
</script>

<style>
.modal-elements .modal-container {
    @apply pt-6 pb-3 border-b border-grey-border !important;
}
.modal-elements .title{
    @apply m-0 !important;
}
#promotion-container input.skitude-input{
    padding-right: 85px;
    @apply border-t-0 h-12 pb-0;
}
#promotion-container input.skitude-input::placeholder{
    @apply normal-case tracking-base;
}
#promotion-container #validate-promo{
    top: -50px;
    right: 25px;
    @apply bg-secondary text-white px-3 py-1 rounded float-right relative;
}
#promotion-container #validate-promo:disabled{
    @apply bg-opacity-50 !important;
}
#promotion-container #remove-promo{
    top: -42px;
    right: 32px;
    @apply relative float-right;
}
#promotion-container #error-promo{
    position: relative;
    top: -6px;
    margin-bottom: -15px;
}
#promotion-container #error-promo:before{
    content: "";
    top: -20px;
    left: 30px;
    z-index: 1;
    border: solid 15px transparent;
    border-bottom-color: #ff4e60;
    @apply absolute;
}
</style>
